import { useCallback, useEffect, useState } from 'react';
import Text from '../../../../components/atoms/text';
import ClientService from '../../../../services/Client.service';
import { useRouteLoaderData } from 'react-router-dom';
import UserService, { IUser } from '../../../../services/User.service';
import Input from '../../../../components/atoms/input';
import Button from '../../../../components/atoms/button';
import { NotificationToast } from '../../../../components/organisms/notification-toast';
import { useTranslation } from 'react-i18next';
import { HomeLoaderData } from '../../../../types/homeLoaderData';

const EnergyCost = () => {
	const { t } = useTranslation();

	const { accountId } = useRouteLoaderData('home') as HomeLoaderData;

	const [currentEnergyCost, setCurrentEnergyCost] = useState<number>(0);
	const [energyCost, setEnergyCost] = useState('');

	useEffect(() => {
		if (!accountId) return;
		const getEnergyCost = async () => {
			const response = await ClientService.getEnergyCost(
				Number(accountId)
			);
			if (!response) return;
			setCurrentEnergyCost(Number(response));
		};

		getEnergyCost();
	}, [accountId]);

	const onSave = async () => {
		const number = Number(energyCost);
		if (!number) return;
		const response = await ClientService.updateEnergyCost(
			Number(accountId),
			number
		);
		if (!response) return;
		setCurrentEnergyCost(number);
		NotificationToast.Success(t('port_management.energy_cost.success'));
	};

	return (
		<div className="flex flex-col gap-2 p-6">
			<Text>
				<b>{t('port_management.energy_cost.cost')}: </b>
				R$ {currentEnergyCost.toFixed(2)}
			</Text>
			<Text>{t('port_management.energy_cost.new_cost')}</Text>
			<div className="flex gap-2">
				<Input
					value={energyCost || ''}
					onChange={(e) => setEnergyCost(e.target.value)}
					type="number"
				/>
				<Button onClick={onSave}>{t('misc.save')}</Button>
			</div>
		</div>
	);
};

export default EnergyCost;
